export const it = {
  // Navigation
  schedule: 'Orario',
  employees: 'Dipendenti',
  vacations: 'Vacanze e Assenze',
  holidays: 'Festività',
  store: 'Negozio',
  statistics: 'Statistiche',
  export: 'Esporta',
  mySchedule: 'Il Mio Orario',
  
  // Common actions
  save: 'Salva',
  cancel: 'Annulla',
  delete: 'Elimina',
  edit: 'Modifica',
  add: 'Aggiungi',
  close: 'Chiudi',
  back: 'Indietro',
  next: 'Avanti',
  previous: 'Precedente',
  search: 'Cerca',
  filter: 'Filtra',
  clear: 'Cancella',
  confirm: 'Conferma',
  loading: 'Caricamento...',
  
  // Authentication
  login: 'Accedi',
  logout: 'Esci',
  username: 'Nome utente',
  password: 'Password',
  loginError: 'Nome utente o password non validi',
  scheduleSystem: 'Sistema Orari',
  loginWithCredentials: 'Accedi con il tuo nome utente e password',
  loggingIn: 'Accesso in corso...',
  testInformation: 'Informazioni di Test',
  
  // Store
  storeSelector: 'Selettore Negozio',
  selectStore: 'Seleziona un negozio',
  newStore: 'Nuovo Negozio',
  storeName: 'Nome Negozio',
  address: 'Indirizzo',
  phone: 'Telefono',
  email: 'Email',
  createStore: 'Crea Negozio',
  editStore: 'Modifica Negozio',
  deleteStore: 'Elimina Negozio',
  storeCreated: 'Negozio creato con successo',
  storeUpdated: 'Negozio aggiornato con successo',
  storeDeleted: 'Negozio eliminato con successo',
  storeSettings: 'Impostazioni Negozio',
  weeklySchedule: 'Orario Settimanale',
  scheduleExceptions: 'Eccezioni Orario',
  addException: 'Aggiungi Eccezione',
  editScheduleException: 'Modifica Eccezione Orario',
  addScheduleException: 'Aggiungi Eccezione Orario',
  updateException: 'Aggiorna Eccezione',
  reasonOptional: 'Motivo (opzionale)',
  openingHours: 'Orari di Apertura',
  noExceptionsConfigured: 'Nessuna eccezione configurata',
  date: 'Data',
  
  // Employees
  employeeName: 'Nome Completo',
  weeklyLimit: 'Limite Settimanale (ore)',
  color: 'Colore Dipendente',
  role: 'Ruolo Dipendente',
  manager: 'Manager',
  employee: 'Dipendente',
  districtManager: 'Manager Distrettuale',
  employeeStartDate: 'Data di Inizio',
  birthday: 'Data di Nascita',
  vacationDays: 'Giorni di Vacanza all\'Anno',
  unavailableTimes: 'Orari Non Disponibili',
  addEmployee: 'Aggiungi Dipendente',
  editEmployee: 'Modifica Dipendente',
  deleteEmployee: 'Elimina Dipendente',
  employeeCreated: 'Dipendente creato con successo',
  employeeUpdated: 'Dipendente aggiornato con successo',
  employeeDeleted: 'Dipendente eliminato con successo',
  newEmployee: 'Nuovo Dipendente',
  regularEmployee: 'Dipendente Regolare',
  mainManager: 'Manager Principale',
  uniqueUsernameForLogin: 'Nome utente univoco per l\'accesso del dipendente',
  passwordForLogin: 'Password per l\'accesso del dipendente',
  employeeList: 'Lista Dipendenti',
  active: 'Attivo',
  inactive: 'Inattivo',
  create: 'Crea',
  update: 'Aggiorna',
  manageEmployeeInfo: 'Gestisci le informazioni dei tuoi dipendenti',
  
  // Schedule
  week: 'Settimana',
  month: 'Mese',
  day: 'Giorno',
  monday: 'Lunedì',
  tuesday: 'Martedì',
  wednesday: 'Mercoledì',
  thursday: 'Giovedì',
  friday: 'Venerdì',
  saturday: 'Sabato',
  sunday: 'Domenica',
  startTime: 'Ora di Inizio',
  endTime: 'Ora di Fine',
  hours: 'Ore',
  duration: 'Durata',
  published: 'Pubblica',
  draft: 'Bozza',
  addShift: 'Crea Turni',
  editShift: 'Modifica Turno',
  deleteShift: 'Elimina Turno',
  copyWeek: 'Copia Settimana',
  repeatWeek: 'Ripeti',
  deleteWeek: 'Elimina Settimana',
  compactMode: 'Modalità Compatta',
  normalMode: 'Modalità Normale',
  thisWeek: 'Questa Settimana',
  copying: 'Copia in corso...',
  clickEmployeeToCreateShift: 'Clicca su un dipendente per creare un turno manualmente',
  view24h: 'Visualizza 24h',
  
  // Absences
  absenceManagement: 'Gestione Assenze',
  absenceType: 'Tipo di Assenza',
  vacation: 'Vacanza',
  sick: 'Malattia',
  personal: 'Personale',
  other: 'Altro',
  absenceStartDate: 'Data di Inizio',
  absenceEndDate: 'Data di Fine',
  reason: 'Motivo',
  status: 'Stato',
  pending: 'In Attesa',
  approved: 'Approvato',
  rejected: 'Rifiutato',
  newRequest: 'Nuova Richiesta',
  requestSubmitted: 'Richiesta inviata con successo',
  remainingVacationDays: 'Giorni di Vacanza Rimanenti',
  type: 'Tipo',
  dates: 'Date',
  days: 'Giorni',
  actions: 'Azioni',
  absenceTypeLabel: 'Tipo di Assenza',
  startDate: 'Data di Inizio',
  endDate: 'Data di Fine',
  employeeInfo: 'Informazioni Dipendente',
  requestDate: 'Data della Richiesta',
  approvedBy: 'Approvato da:',
  rejectedBy: 'Rifiutato da:',
  rejectionReason: 'Motivo del rifiuto:',
  manageAllAbsenceRequests: 'Gestisci tutte le richieste di assenza',
  totalAbsences: 'Totale Assenze',
  allTypes: 'Tutti i tipi',
  allStatuses: 'Tutti gli stati',
  allEmployees: 'Tutti i dipendenti',
  requestDetails: 'Dettagli della Richiesta',
  name: 'Nome',
  absenceInformation: 'Informazioni Assenza',
  scheduleRestrictions: 'Restrizioni orario',
  shiftPendingPublication: 'turno in attesa di pubblicazione',
  shiftsPendingPublication: 'turni in attesa di pubblicazione',
  defineOpeningHoursAndExceptions: 'Definisci orari di apertura ed eccezioni',
  open: 'Aperto',
  closed: 'Chiuso',
  opens: 'Apre',
  closes: 'Chiude',
  range: 'Intervallo',
  addRange: 'Aggiungi intervallo',
  addAnotherRange: 'Aggiungi altro intervallo',
  lastSynchronization: 'Ultima sincronizzazione',
  holidayInformation: 'Informazioni Festività',
  nationalHolidaysSyncAutomatically: 'Le festività nazionali vengono sincronizzate automaticamente ogni anno. Questi giorni vengono automaticamente considerati giorni non lavorativi nella pianificazione degli orari.',
  
  // Statistics
  coverageAndWorkloadMetrics: 'Metriche di copertura e carico di lavoro',
  activeEmployees: 'Dipendenti Attivi',
  shiftsThisWeek: 'Turni Questa Settimana',
  totalHours: 'Totale Ore',
  statisticsByEmployee: 'Statistiche per Dipendente',
  assignedHours: 'Ore Assegnate',
  weeklyCap: 'Limite Settimanale',
  utilization: '% Utilizzo',
  busiestDay: 'Giorno Più Affollato',
  daysWithoutWeekend: 'Giorni Senza Weekend',
  
  // Export
  exportSchedules: 'Esporta Orari',
  exportPublishedSchedulesInDifferentFormats: 'Esporta orari pubblicati in diversi formati',
  ical: 'iCal',
  google: 'Google',
  noPublishedSchedulesToExport: 'Nessun orario pubblicato da esportare',
  
  // Additional UI elements
  newAbsenceRequest: 'Nuova Richiesta di Assenza',
  selectEmployee: 'Seleziona dipendente',
  describeAbsenceReason: 'Descrivi il motivo dell\'assenza...',
  submitting: 'Invio in corso...',
  submitRequest: 'Invia Richiesta',
  vacationsAndAbsences: 'Vacanze e Assenze',
  requestVacation: 'Richiedi Vacanza',
  newVacationRequest: 'Nuova Richiesta di Vacanza',
  myVacationRequests: 'Le Mie Richieste di Vacanza',
  clickRequestVacationToCreateFirstRequest: 'Clicca "Richiedi Vacanza" per creare la tua prima richiesta',
  vacationManagement: 'Gestione Vacanze',
  vacationRequests: 'Richieste di Vacanza',
  
  // Absence Types
  sickness: 'Malattia',
  unjustified: 'Assenza Ingiustificata',
  special: 'Permesso Speciale',
  
  // Holidays
  holidayName: 'Nome Festività',
  holidayDate: 'Data Festività',
  addHoliday: 'Aggiungi',
  editHoliday: 'Modifica Festività',
  automaticHolidayManagement: 'Gestione automatica delle festività nazionali',
  addCustomHoliday: 'Aggiungi Festività Personalizzata',
  editCustomHoliday: 'Modifica Festività Personalizzata',
  updateHoliday: 'Aggiorna Festività',
  nationalHolidays: 'Festività Nazionali',
  loadingHolidays: 'Caricamento festività...',
  deleteHoliday: 'Elimina Festività',
  
  // Statistics
  totalEmployees: 'Totale Dipendenti',
  totalShifts: 'Totale Turni',
  averageHours: 'Ore Medie',
  coverageProblems: 'Problemi di Copertura',
  noProblems: 'Nessun problema di copertura rilevato',
  gap: 'Gap',
  conflict: 'Conflitto',
  overtime: 'Straordinario',
  emptyDay: 'Nessun turno',
  weeklyOvertime: 'Straordinario settimanale',
  storeClosed: 'Negozio chiuso',
  
  // Export
  exportData: 'Esporta Dati',
  selectDateRange: 'Seleziona Intervallo Date',
  from: 'Da',
  to: 'A',
  exportFormat: 'Formato di Esportazione',
  excel: 'Excel',
  csv: 'CSV',
  exportSuccess: 'Dati esportati con successo',
  
  // Configuration
  configuration: 'Configurazione',
  language: 'Lingua dell\'Applicazione',
  country: 'Paese (per festività)',

  // Header
  scheduleAdministrationPanel: 'Pannello di Amministrazione Orari',
  welcome: 'Benvenuto',
  invalidDay: 'Giorno non valido',

  // Keyboard Shortcuts
  keyboardShortcuts: 'Scorciatoie da Tastiera',
  showHideShortcutsHelp: 'Mostra/nascondi aiuto scorciatoie',
  toggleDarkMode: 'Attiva/disattiva modalità scura',
  closeModalsAndPanels: 'Chiudi modali e pannelli',
  openNotificationCenter: 'Apri centro notifiche',
  goToScheduleTab: 'Vai alla scheda Orari',
  goToEmployeesTab: 'Vai alla scheda Dipendenti',
  goToConfigurationTab: 'Vai alla scheda Configurazione',
  goToStatisticsTab: 'Vai alla scheda Statistiche',
  goToExportTab: 'Vai alla scheda Esporta',
  createNewShift: 'Crea nuovo turno',
  saveSchedules: 'Salva orari',
  publishSchedules: 'Pubblica orari',
  navigateBetweenWeeks: 'Naviga tra settimane',
  zoomInOut: 'Zoom avanti/indietro',
  resetZoom: 'Reimposta zoom',
  addNewEmployee: 'Aggiungi nuovo dipendente',
  searchEmployees: 'Cerca dipendenti',
  saveEmployee: 'Salva dipendente',
  cancelEdit: 'Annulla modifica',
  refreshStatistics: 'Aggiorna statistiche',
  exportStatistics: 'Esporta statistiche',
  refreshSchedules: 'Aggiorna orari',
  pressCtrlSlashToShowHideHelp: 'Premi Ctrl + / per mostrare/nascondere questo aiuto',

  // Keyboard Shortcut Categories
  general: 'Generale',
  navigation: 'Navigazione',
  schedules: 'Orari',

  // Coverage Problems
  gapWithoutCoverage: 'Gap senza copertura di',
  excessiveWorkday: 'Giornata lavorativa eccessiva',
  noShifts: 'Nessun turno',
  excessiveWeeklyHours: 'Ore settimanali eccessive',
  problem: 'Problema',
  
  // Notifications
  notifications: 'Notifiche',
  noNotifications: 'Nessuna notifica',
  birthdayToday: 'Compleanno oggi',
  reviewAssignments: 'Rivedi assegnazioni',
  verifyAllEmployeesHaveAssignedSchedules: 'Verifica che tutti i dipendenti abbiano orari assegnati',
  notification: 'notifica',
  
  // Errors
  error: 'Errore',
  success: 'Successo',
  warning: 'Avviso',
  info: 'Informazione',
  required: 'Questo campo è obbligatorio',
  invalidDate: 'Data non valida',
  invalidTime: 'Ora non valida',
  networkError: 'Errore di rete. Riprova.',
  
  // Confirmations
  confirmDelete: 'Sei sicuro di voler eliminare questo elemento?',
  confirmDeleteWeek: 'Sei sicuro di voler eliminare tutti i turni di questa settimana? Questa azione non può essere annullata.',
  confirmDeleteAll: 'Sei sicuro di voler eliminare TUTTI i dati? Questa azione eliminerà tutti i negozi, dipendenti e turni. Questa azione non può essere annullata.',
  
  // Time formats
  timeFormat: 'HH:MM',
  defaultDateFormat: 'DD/MM/AAAA',
  
  // Days of week
  daysOfWeek: {
    monday: 'Lun',
    tuesday: 'Mar',
    wednesday: 'Mer',
    thursday: 'Gio',
    friday: 'Ven',
    saturday: 'Sab',
    sunday: 'Dom'
  },

  // Store Management
  storeManagement: 'Gestione Negozi',
  welcomeSelectStore: 'Benvenuto, {name}. Seleziona un negozio da gestire o creane uno nuovo.',
  activeStores: 'Negozi Attivi',
  storeList: 'Lista Negozi',
  generateTestData: 'Genera Dati di Test',
  noStoresYet: 'Nessun negozio creato ancora',
  createFirstStore: 'Crea il tuo primo negozio per iniziare a gestire orari e dipendenti.',
  storeAddress: 'Indirizzo',
  storePhone: 'Telefono',
  storeEmail: 'Email',
  storeNamePlaceholder: 'Es: Negozio Centrale',
  storeAddressPlaceholder: 'Es: Via Principale 123',
  storePhonePlaceholder: 'Es: +39 06 1234 5678',
  storeEmailPlaceholder: 'Es: negozio@azienda.com',
  editStoreTitle: 'Modifica Negozio',
  createStoreTitle: 'Crea Nuovo Negozio',
  storeNameRequired: 'Il nome del negozio è obbligatorio',
  confirmDeleteStore: 'Sei sicuro di voler eliminare il negozio "{storeName}"? Questa azione non può essere annullata.',
  shifts: 'Turni',
  manageStore: 'Gestisci Negozio',

  // Date Format
  dateFormat: 'Formato Data',
  dateFormatDDMMYYYY: 'DD/MM/AAAA',
  dateFormatMMDDYYYY: 'MM/DD/AAAA',
  dateFormatYYYYMMDD: 'AAAA/MM/DD',

  // Employee Dashboard
  mySchedules: 'I Miei Orari',
  welcomeEmployee: 'Benvenuto, {name}',
  previousWeek: 'Settimana Precedente',
  nextWeek: 'Prossima Settimana',
  thisMonth: 'Questo Mese',
  myShifts: 'I Miei Turni',
  shiftCalendar: 'Calendario Turni',
  list: 'Lista',
  calendar: 'Calendario',
  noShiftsThisWeek: 'Non hai turni assegnati questa settimana',
  noShiftsThisMonth: 'Non hai turni assegnati questo mese',
  previousMonth: 'Mese Precedente',
  nextMonth: 'Prossimo Mese',
  closeSession: 'Esci'
};
